import { useMutation, useQueryClient } from '@tanstack/react-query';
import { massForceDeleteContacts } from '../../api/apiContacts';
import toast from 'react-hot-toast';

export const useForceDeleteAllContacts = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ items }) => massForceDeleteContacts(items || []),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['contacts'] });
            toast.success(data.message || 'Messages permanently deleted successfully');
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Failed to permanently delete messages';
            toast.error(errorMessage);
        },
    });
};